import React from 'react';
import { cn } from '../../lib/utils';
export function Card({
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('bg-navy-700 border border-navy-600 p-6 md:p-8 relative group hover:border-gold-500/50 transition-colors duration-300', className)} {...props} data-id="element-385">
      {/* Corner accents */}
      <div className="absolute top-0 left-0 w-2 h-2 border-t border-l border-gold-500/30 group-hover:border-gold-500 transition-colors" data-id="element-386"></div>
      <div className="absolute top-0 right-0 w-2 h-2 border-t border-r border-gold-500/30 group-hover:border-gold-500 transition-colors" data-id="element-387"></div>
      <div className="absolute bottom-0 left-0 w-2 h-2 border-b border-l border-gold-500/30 group-hover:border-gold-500 transition-colors" data-id="element-388"></div>
      <div className="absolute bottom-0 right-0 w-2 h-2 border-b border-r border-gold-500/30 group-hover:border-gold-500 transition-colors" data-id="element-389"></div>

      {children}
    </div>;
}